module.exports = __webpack_public_path__ + "img/AM_Banner_Lotería-2022.4ebaeda7.jpg";